import type { AccentHue } from "@repo/fika-design-system/color"
import type { TagTargetType } from "@repo/fika-shared/src/loader/tags-schema"
import { For, Show } from "solid-js"
import { ulid } from "ulid"
import { useAppContext } from "@/context/app"
import { Box } from "../components/box"
import { TagSelector } from "../components/tagSelector"
import {
  tagSuggestionClass,
  tagSuggestionListClass,
} from "./tags-with-suggestions.css"

export function TagWithSuggestions(props: {
  options: string[]
  tags: Set<string>
  suggestions: string | null
  targetType: TagTargetType
  targetId: string
  hue: AccentHue
}) {
  const { replicache } = useAppContext()

  function onChange(tags: string[]) {
    replicache.mutate.setTags({
      target_id: props.targetId,
      target_type: props.targetType,
      tags: tags.map(tag => ({
        id: ulid(),
        target_id: props.targetId,
        target_type: props.targetType,
        tag,
      })),
    })
  }

  function onClickSuggestion(tag: string) {
    if (props.tags.has(tag)) return
    onChange([...Array.from(props.tags), tag])
  }

  return (
    <Box gap="12">
      <TagSelector
        options={props.options}
        hue={props.hue}
        value={Array.from(props.tags)}
        onChange={onChange}
      />
      <TagSuggestions
        suggestions={props.suggestions}
        tags={props.tags}
        onClickSuggestion={onClickSuggestion}
      />
    </Box>
  )
}

export function TagSuggestions(props: {
  suggestions: string | null
  tags?: Set<string>
  onClickSuggestion?: (tag: string) => void
}) {
  return (
    <Show when={props.suggestions}>
      {suggestions => (
        <ul class={tagSuggestionListClass}>
          <For
            each={suggestions()
              .split(",")
              .filter(tag => !props.tags?.has(tag))}
          >
            {tag => (
              <li>
                <button
                  type="button"
                  class={tagSuggestionClass}
                  onClick={() => props.onClickSuggestion?.(tag)}
                >
                  {tag}
                </button>
              </li>
            )}
          </For>
        </ul>
      )}
    </Show>
  )
}
